import React from "react";
import { Users } from "lucide-react";
import FunnelAssessmentViewerV2Base from "./FunnelAssessmentViewerV2Base";

const FunnelCustomerLifetimeEconomicsAssessmentViewerV2 = ({ markdown }) => (
  <FunnelAssessmentViewerV2Base
    markdown={markdown}
    title="Customer Lifetime Economics"
    subtitle="Repeat behavior and long-term value durability"
    badge="LTV"
    Icon={Users}
  />
);

export default FunnelCustomerLifetimeEconomicsAssessmentViewerV2;
